import * as React from "react";
import {OverlayPanel} from "@bizform/primereact/components/overlaypanel/OverlayPanel";
import {DomHelper} from "@bizform/helper/dist/js/bizflow/helper.min";
import {WindowKey} from "@bizform/type/model/model/WindowKey.model";

type Props = {
    name: string;
    email?: string;
    id?: string;
    loginId?: string;
    nameClass?: any;
    nameStyle?: any;
    showButton: Boolean;
};
type State = {
};

export class UserUI extends React.Component<Props, State> {
    private _ref: any;
    constructor(props) {
        super(props);

        this._setRef = this._setRef.bind(this);
    }

    render() {
        const showButton = (typeof this.props.showButton !== "boolean") ? !!this.props.showButton : this.props.showButton;
        const checker = window[WindowKey.DESIGNMODE] ? showButton : showButton && this.props && (this.props.loginId || this.props.email);
        return (
            <div>
                <span className={this.props.nameClass} style={this.props.nameStyle}>
                {this.props && this.props.name ? this.props.name : "No name"}
                {checker ?
                    <React.Fragment>
                        <i className="fas fa-plus-circle pl-1 bf-cursor-pointer" onClick={(e) => this._ref.toggle(e)} />
                        <OverlayPanel ref={this._setRef} dismissable={true} appendTo={DomHelper.getForOverLayDom()} className={"bf-bg-theme bf-text-theme"}>
                            <div style={{minWidth: "250px"}}>
                                {this.props.loginId ? <div className="row">
                                    <div className="col-4">Login ID</div>
                                    <div className="col-8" style={{wordWrap: "break-word"}}>{this.props.loginId}</div>
                                </div> : null}
                                {this.props.email ? <div className="row">
                                    <div className="col-4">Email</div>
                                    <div className="col-8" style={{wordWrap: "break-word"}}>{this.props.email}</div>
                                </div> : null}
                                {!this.props.loginId && !this.props.email ? <div>Login ID</div> : null}
                            </div>
                        </OverlayPanel>
                    </React.Fragment>
                : null}
                </span>
            </div>
        );
    }

    private _setRef(el: any) {
        if (el && el.container) {
            this._ref = el;
        }
    }
}